import type { SVGProps } from 'react';
import { INTEGRATION_BRANDS } from '@/lib/brand/integration-brands';

// Veeqo icon - the blue square with white V mark
const Veeqo = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 55 55" fill="none">
    <path
      fill={INTEGRATION_BRANDS.veeqo.primary}
      d="M54.27 42.36V11.91c0-6.57-5.34-11.91-11.91-11.91H11.91C5.33 0 0 5.34 0 11.91v30.45c0 6.57 5.34 11.91 11.91 11.91h30.45c6.57 0 11.91-5.34 11.91-11.91z"
    />
    <path
      fill="#fff"
      d="M43.79 38.78V13.58c0-1.7-1.37-3.07-3.07-3.07H15.52c-1.86 0-2.78 2.24-1.45 3.53l26.22 26.22c1.26 1.29 3.5.35 3.5-1.48z"
    />
  </svg>
);

export { Veeqo };
